import React from 'react'

import { LP_PAIR_SYMBOL } from '@/constants/lpPair'
import { nutrimaticLabels } from '@/nutrimatic'
import CurrencyLogo from '@/components/CurrencyLogo'
import { Pair } from '@/sdk'
import { useAppWeb3 } from '@/hooks'
import { useLiquidityPositionMetrics } from '@/features/liquidity/useLiquidityPositionMetrics'
import { unwrappedToken } from '@/utils/wrappedCurrency'

/** Contenido de detalle LP para el readout izquierdo (sin acciones). */
export function LiquidityNutrimaticPositionReadoutDetail({ pair }: { pair: Pair }) {
  const { account } = useAppWeb3()
  const metrics = useLiquidityPositionMetrics(pair, account)
  const c0 = unwrappedToken(pair.token0)
  const c1 = unwrappedToken(pair.token1)
  const shareLabel = metrics.poolShare?.toFixed(4) ?? '—'

  return (
    <div className="nm-tablet-readout-pane__detail space-y-5 p-4">
      <div className="flex items-center gap-3">
        <div className="flex -space-x-2">
          <CurrencyLogo currency={c0} size="32px" />
          <CurrencyLogo currency={c1} size="32px" />
        </div>
        <div className="min-w-0">
          <p className="nm-tablet-readout-pane__kicker">{nutrimaticLabels.liquidityHub.readoutKicker}</p>
          <p className="font-mono text-sm tabular-nums text-foreground">
            {c0.symbol}/{c1.symbol}
          </p>
          <p className="font-mono text-xs tabular-nums text-muted-foreground">
            {metrics.lpBalance} {LP_PAIR_SYMBOL} · {shareLabel}% del pool
          </p>
        </div>
      </div>

      <div className="nm-tablet-readout-pane__metric-grid">
        <div className="nm-tablet-readout-pane__metric">
          <span className="nm-tablet-readout-pane__metric-label">{metrics.token0Symbol} en tu posición</span>
          <span className="nm-tablet-readout-pane__metric-value">{metrics.token0Amount}</span>
        </div>
        <div className="nm-tablet-readout-pane__metric">
          <span className="nm-tablet-readout-pane__metric-label">{metrics.token1Symbol} en tu posición</span>
          <span className="nm-tablet-readout-pane__metric-value">{metrics.token1Amount}</span>
        </div>
        <div className="nm-tablet-readout-pane__metric">
          <span className="nm-tablet-readout-pane__metric-label">Precio spot (pool)</span>
          <span className="nm-tablet-readout-pane__metric-value">{metrics.price}</span>
        </div>
        <div className="nm-tablet-readout-pane__metric">
          <span className="nm-tablet-readout-pane__metric-label">Reservas totales</span>
          <span className="nm-tablet-readout-pane__metric-value">
            {metrics.reserve0} / {metrics.reserve1}
          </span>
          <span className="nm-tablet-readout-pane__metric-label">
            {metrics.token0Symbol} / {metrics.token1Symbol}
          </span>
        </div>
      </div>
    </div>
  )
}
